export const sleep = {
  id: 'sleep',
  state: 'sleep',
  system: false,

  enter(ctx) {
    ctx.movement.stopWalk();
    ctx.stateTimer = ctx.getStateDuration('sleep');
  },

  update(ctx, dt) {
    if (!ctx.movement.isGrounded()) {
      ctx.transition('fall');
      return;
    }
    ctx.stateTimer -= dt;
    if (ctx.stateTimer <= 0) ctx.transitionToNext();
  },

  exit() {},
};
